import React from 'react'
import Experience from './Experience.jsx'

import EXPERIENCE_DECISION_IMAGE_PATH from 'images/experience_decision.jpg'
import EXPERIENCE_DECISION_SONG_PATH from 'audio/7. DESEOS.mp3'

const DecisionText = () => (
	<span className="text-center">
		<p>Existir como base sólida para tus necesidades.</p>
		<p>Cuánto espacio de silencio.</p>
		<p>Descanso y nutrición.</p>
		<p>Cuestionamiento y aceptación.</p>
		<p>Placer.</p>
		<p>Movimiento y quietud.</p>
		<p>Espontaneidad y retracción.</p>
		<p>Exposición.</p>


		<p>¿Cuánto espacio de espacio?</p>

		<p>¿Alojas las necesidades de tu alma?</p>
		<p>Y, ¿las de tu cuerpo?</p>

		<p>¿Qué te decís cuando cerras tus ojos y te permitís el espacio de sentir?</p>
		<p>Y ahora,</p>
		<p>¿Estás lista para danzar?</p>
	</span>
)

const ExperienceDecision = ({ is_active, ...props }) => {
	return (<Experience
		image={EXPERIENCE_DECISION_IMAGE_PATH}
		title={"Decisión"}
		phrase={"¿Qué espacio necesita tu existencia hoy?"}
		phrase_rect={{ top: 54, left: 88, width: 13, height: 50 }}
		text={<DecisionText />}
		text_rect={{ top: 38.5, left: 51, width: 53, height: 73 }}
		text_interaction_zone_rect={{ top: 37, left: 22.5, width: 8, height: 10 }}
		song={EXPERIENCE_DECISION_SONG_PATH}
		song_rect={{ top: 84.2, left: 51.3, width: 10, height: 10 }}
		is_active={is_active}
		{...props}
	/>)
}

export default ExperienceDecision